import React, { useState, useEffect } from "react";
import { Container, Card, Col, Row, Spinner, Table } from "react-bootstrap";

import userperfil from "../../images/userperfil.png";
import logoImg from "../../images/ModuloCapacitacion/Logo.png";
import grupoFarinterImg from "../../images/ModuloCapacitacion/grupoFarinter.png";

import "../../css/capacitacion.css";

const NineBoxesPDF = (props) => {
  const renderSwitch = (param) => {
    switch (param.type) {
      case "paragraph":
        return (
          <p
            style={{
              textAlign: `${param.data.alignment}`,
            }}
            dangerouslySetInnerHTML={{ __html: param.data.text }}
          />
        );
      case "header":
        switch (param.data.level) {
          case 1:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 2:
            return (
              <h1
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 3:
            return (
              <h3
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 4:
            return (
              <h4
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 5:
            return (
              <h5
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          case 6:
            return (
              <h6
                style={{
                  textAlign: `${param.tunes.anyTuneName.alignment}`,
                }}
                dangerouslySetInnerHTML={{ __html: param.data.text }}
              />
            );
          default:
            return null;
        }
      case "breakLine":
        return <br />;
      default:
        return null;
    }
  };

  return (
    <>
      <div id="prueba" style={{ position: "absolute", top: "-99999999999px" }}>
        <Container fluid>
          <div id="impresion1" className="mt-5">
            <Col>
              <Row>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={logoImg}
                    style={{ width: "40%" }}
                    alt="LogoAurora"
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={grupoFarinterImg}
                    style={{ width: "40%" }}
                    alt="LogoFarinter"
                  />
                </Col>
              </Row>
            </Col>
            <Row
              style={{ backgroundColor: "#141e30", color: "white" }}
              className="rounded py-3 my-3 d-flex flex-wrap justify-content-center align-items-center"
            >
              <h1>Matriz 9 cajas</h1>
            </Row>
            <Row className="my-5 d-flex flex-wrap justify-content-center align-items-center">
              <Col md={10} className="mt-5">
                <Table striped bordered>
                  <tbody>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Solicita:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>
                          {props.solicitador}
                        </h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Empresa:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>
                          {props.emps &&
                            props.emps.map((item, index) => (
                              <>{props.emps[index + 1] ? `${item},` : item}</>
                            ))}
                        </h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Unidad Organiztiva:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>
                          {props.areas &&
                            props.areas.map((item, index) => (
                              <>{props.areas[index + 1] ? `${item},` : item}</>
                            ))}
                        </h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>División:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>
                          {props.division &&
                            props.division.map((item, index) => (
                              <>
                                {props.division[index + 1] ? `${item},` : item}
                              </>
                            ))}
                        </h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Colaborador:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>
                          {props.colaboradores &&
                            props.colaboradores.map((item, index) => (
                              <>
                                {props.colaboradores[index + 1]
                                  ? `${item},`
                                  : item}
                              </>
                            ))}
                        </h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Fecha inicio:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>{props.fechaInicio?props.fechaInicio:""}</h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Fecha fin:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>{props.fechaFin?props.fechaFin:""}</h1>
                      </td>
                    </tr>
                    <tr>
                      <td className="text-right" style={{ width: "500px" }}>
                        <h1>
                          <b>Fecha:</b>
                        </h1>
                      </td>
                      <td className="text-left">
                        <h1 style={{ fontWeight: "normal" }}>{props.fecha}</h1>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>
          <div id="impresion2">
            <Col>
              <Row>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={logoImg}
                    style={{ width: "40%" }}
                    alt="LogoAurora"
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={grupoFarinterImg}
                    style={{ width: "40%" }}
                    alt="LogoFarinter"
                  />
                </Col>
              </Row>
            </Col>
            <Row
              style={{ backgroundColor: "#141e30", color: "white" }}
              className="rounded my-3 d-flex flex-wrap justify-content-center align-items-center"
            >
              <Col md={6} className="py-4 border border-white">
                <Col>
                  <h1>
                    <b>Matriz 9 cajas</b>
                  </h1>
                </Col>
                <Col>
                  <h3>
                    Colaborador:{" "}
                    {!props.employees ||
                    !props.employees[0] ||
                    (props.employees && props.employees.length > 1)
                      ? null
                      : props.employees[0].nombre}
                  </h3>
                </Col>
                <Col>
                  <h3>
                    División:{" "}
                    {!props.divisions ||
                    !props.divisions[0] ||
                    (props.divisions && props.divisions.length > 1)
                      ? null
                      : props.divisions[0].descripcion}
                  </h3>
                </Col>
              </Col>
              <Col md={6} className="py-4 border border-white">
                <Col>
                  <h1>
                    <b>Resultados</b>
                  </h1>
                </Col>
                <Col>
                  <h3>
                    Desempeño:{" "}
                    {props.desempenio_promedio
                      ? `${props.desempenio_promedio}%`
                      : "0%"}
                  </h3>
                </Col>
                <Col>
                  <h3>
                    Potencial:{" "}
                    {props.potencial_promedio
                      ? `${props.potencial_promedio}%`
                      : "0%"}
                  </h3>
                </Col>
              </Col>
            </Row>
            <Col md={10} className="my-5 mx-auto">
              <Row>
                <Col className="my-3 mx-auto">
                  <Row>
                    <div
                      className="mb-5 pr-0 d-flex flex-wrap justify-content-center align-items-center text-justify"
                      xs="auto"
                      style={{ width: "20px" }}
                    >
                      <div id="mark">
                        <b>Potencial</b>
                      </div>
                    </div>
                    <Col>
                      <Row className="mx-0">
                        {props.nineBoxes &&
                          props.nineBoxes.data
                            .sort((a, b) =>
                              a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
                            )
                            .map((item, index) => (
                              <>
                                <Col
                                  md="4"
                                  xs="auto"
                                  className="mb-3 d-flex px-0 mx-auto"
                                >
                                  <Card
                                    // className="mb-3 px-0 border border-muted rounded shadow-sm bg-white"
                                    className="mb-3 border border-white px-0 bg-white w-100 h-100"
                                    // style={{ border: "1px solid #ced4da" }}
                                  >
                                    <Card.Header
                                      className={`${
                                        index === 0 ||
                                        index === 4 ||
                                        index === 8
                                          ? "bg-warning"
                                          : index === 1 || index === 5
                                          ? "bg-success"
                                          : index === 2
                                          ? "bg-info"
                                          : index === 6
                                          ? "bg-danger"
                                          : "colorMedio"
                                      } font-weight-bold d-flex flex-wrap justify-content-justify align-items-center text-light`}
                                    >
                                      <p>{item.encabezado_cuadrante}</p>
                                    </Card.Header>
                                    <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between">
                                      {item.empleados.map((_item) => (
                                        <div>
                                          <Row className="px-2 d-flex flex-wrap justify-content-justify align-items-center">
                                            <Col md={3}>
                                              <img
                                                src={
                                                  _item.foto
                                                    ? `${process.env.REACT_APP_URL}/media/${_item.foto}`
                                                    : userperfil
                                                }
                                                style={{ width: "100%" }}
                                                className="rounded shadow"
                                                alt="User perfil"
                                              />
                                            </Col>
                                            <Col md={9} className="py-3">
                                              <h6 className="font-weight-bold text-uppercase">
                                                {_item.nombre}
                                              </h6>
                                              <p className="text-uppercase ">
                                                {_item.Funcion_List &&
                                                  _item.Funcion_List.length >
                                                    0 &&
                                                  _item.Funcion_List[0]
                                                    .descripcion}
                                              </p>
                                            </Col>
                                          </Row>
                                          <hr className="m-0" />
                                        </div>
                                      ))}
                                    </Card.Body>
                                  </Card>
                                </Col>
                              </>
                            ))}
                      </Row>
                      <Col
                        className="py-3 d-flex flex-wrap justify-content-center align-items-center text-justify"
                        xs="auto"
                      >
                        <b>Desempeño</b>
                      </Col>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Col>
          </div>
          <div id="impresion3" className="mt-5">
            <Col>
              <Row>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={logoImg}
                    style={{ width: "40%" }}
                    alt="LogoAurora"
                  />
                </Col>
                <Col
                  md={6}
                  className="d-flex flex-wrap justify-content-center align-items-center"
                >
                  <img
                    src={grupoFarinterImg}
                    style={{ width: "40%" }}
                    alt="LogoFarinter"
                  />
                </Col>
              </Row>
            </Col>
            <Row
              style={{ backgroundColor: "#141e30", color: "white" }}
              className="rounded py-3 my-3 d-flex flex-wrap justify-content-center align-items-center"
            >
              <h1>Significado</h1>
            </Row>
            <Col className="mt-5">
              <Row className="mx-0">
                {props.nineBoxes &&
                  props.nineBoxes.data
                    .sort((a, b) =>
                      a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
                    )
                    .map((item, index) => (
                      <>
                        <Col
                          md="4"
                          xs="auto"
                          className="mb-3 d-flex px-0 mx-auto"
                        >
                          <Card
                            // className="mb-3 px-0 border border-muted rounded shadow-sm bg-white"
                            className="mb-3 border border-white px-0 bg-white w-100 h-100"
                            // style={{ border: "1px solid #ced4da" }}
                          >
                            <Card.Header
                              className={`bg-primary text-light font-weight-bold d-flex flex-wrap justify-content-justify align-items-center text-light`}
                            >
                              <p>{item.encabezado_cuadrante}</p>
                            </Card.Header>
                            <Card.Body className="py-3 px-4 flex-wrap justify-content-between align-items-between">
                              {item.descripcion_cuadrante.map((item) =>
                                renderSwitch(item)
                              )}
                            </Card.Body>
                          </Card>
                        </Col>
                      </>
                    ))}
              </Row>
            </Col>
          </div>
        </Container>
      </div>
    </>
  );
};

export default NineBoxesPDF;
